import { render, staticRenderFns } from "./AskPropsWindow.vue?vue&type=template&id=6c851fcd&scoped=true&"
import script from "./AskPropsWindow.vue?vue&type=script&lang=js&"
export * from "./AskPropsWindow.vue?vue&type=script&lang=js&"
import style0 from "./AskPropsWindow.vue?vue&type=style&index=0&id=6c851fcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c851fcd",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QInput,QBtn,QMenu,QList,QItemSection,QField,QToggle,QSelect,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QInput,QBtn,QMenu,QList,QItemSection,QField,QToggle,QSelect,QSeparator,QCardActions}, component.options.components || {})
